import React, { Component } from 'react';
import RaisedButton from 'material-ui/RaisedButton'
import muiThemeable from 'material-ui/styles/muiThemeable';

import HomeGalleryHeader from './HomeGalleryHeader';
import HomeGalleryFooter from './HomeGalleryFooter';
import {Body1} from './Typography';
import GetInTouchSection from './GetInTouchSection';
import HeroSection from './HeroSection';


export default muiThemeable()(class PaymentDeclinedPage extends Component {

  render() {
    return (
      <div>
        <HomeGalleryHeader />
        <div
          style={{
            backgroundColor: this.props.muiTheme.palette.canvasColor,
          }}>

          <HeroSection
            header="Sorry, there was a problem with billing." />

          <div
            style={{
              width: '500px',
              maxWidth: '90%',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: "left",
            }}>

            <Body1 style={{marginBottom: "20px", marginTop: "50px"}}>
              Your payment processor declined the transaction. Double check that you typed everything correctly.
            </Body1>
            <RaisedButton onClick={() => document.location = '/setup-billing'}>Try Again</RaisedButton>

          </div>

          <GetInTouchSection />

        </div>
        <HomeGalleryFooter />
    </div>
    );
  }
});



// WEBPACK FOOTER //
// ./src/PaymentDeclinedPage.js